<template>
    <div class="d-flex flex-column h-100 text-left">
        <Title
            @input="(title) => ($v.form.title.$model = title)"
            :value.sync="$v.form.title.$model"
            :placeholder="$t('form.placeholder.writeTheTextHere')"
            :state="checkFieldState($v.form.title)"
        />
        <SelectKeyResult
            v-if="showSelectKrField"
            :existentSelectedKeyResultId="form.key_result_id"
            :label="$t('keyResult.keyResult')"
            @updateValue="saveAlreadySelectedKrInForm($event)"
            ref="selectKeyResult"
        />
        <Responsible
            :label="$t('form.label.owner')"
            :value.sync="$v.form.responsible.$model"
            :state="checkFieldState($v.form.responsible)"
            :placeholder="$t('form.placeholder.selectResponsible')"
            :showLabels="true"
            :hideSelected="false"
            :alreadySelectedUserId="form.user_id"
            @already-selected-user="saveAlreadySelectedUserInForm($event)"
            ref="responsible"
        />
        <DueDate
            @input="(date) => ($v.form.due_date.$model = date)"
            :value.sync="$v.form.due_date.$model"
            :placeholder="$t('form.date.endDate')"
        />
        <Status @change="(status) => ($v.form.status.$model = status)" :value.sync="$v.form.status.$model" />
        <div class="ml-auto mt-auto">
            <b-button variant="outline-primary" class="mr-2" :disabled="isSubmitting" @click="onClickCancel">{{
                $t('form.button.cancel')
            }}</b-button>
            <b-button variant="primary" :disabled="isSubmitting" @click="onClickSubmit">
                <span v-if="isSubmitting">
                    <i class="fa fa-spinner fa-spin" />
                </span>
                <span v-if="!isSubmitting"> {{ $t('form.button.save') }} </span>
            </b-button>
        </div>
    </div>
</template>
<script>
import { Title, DueDate, Status } from '@/views/okr/initiatives/form-fields'
import { Users as Responsible } from '@/views/components/fields'
import SelectKeyResult from '@/views/okr/initiatives/link-key-result/components/SelectKeyResult'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import api from '@/services/api'

const DEFAULT_FORM_DATA = {
    title: null,
    key_result_id: null,
    responsible: null,
    due_date: null,
    status: 'todo',
}

export default {
    mixins: [validationMixin],
    components: {
        Title,
        Responsible,
        SelectKeyResult,
        DueDate,
        Status,
    },
    validations: {
        form: {
            title: { required },
            key_result_id: {},
            responsible: { required },
            due_date: {},
            status: {},
        },
    },
    props: {
        initiativeId: Number,
        isSubmitting: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapState('profile', ['currentUserID', 'user']),
        showSelectKrField() {
            return this.user.has_modules.includes('has_okr')
        },
    },
    data() {
        return {
            form: { ...DEFAULT_FORM_DATA },
        }
    },
    methods: {
        saveAlreadySelectedUserInForm(event) {
            this.$v.form.responsible.$model = event
        },
        saveAlreadySelectedKrInForm(kr) {
            if (kr && kr.value) {
                this.form.key_result_id = kr.value
            }
        },
        setInitiative() {
            api.get('/initiatives/' + this.initiativeId)
                .then((resp) => {
                    const { due_date, title, status, user_id, key_result_id } = resp.data.data
                    this.form.title = title
                    this.form.due_date = due_date
                    this.form.status = status
                    setTimeout(() => {
                        this.form.key_result_id = key_result_id
                    }, 2000)
                    this.$set(this.form, 'user_id', user_id.toString())
                    this.$nextTick(() => this.$refs.responsible.loadUsers())
                })
                .catch((e) => {
                    console.error(e)
                })
        },
        onClickCancel() {
            this.resetFormData()
            this.$emit('cancel')
        },
        onClickSubmit() {
            if (!this.formIsValid()) {
                return
            }

            const payload = this.parseFormToApi()
            this.$emit('submit', payload)
            this.resetFormData()
        },
        formIsValid() {
            this.$v.$touch()
            return this.checkFieldState(this.$v.form)
        },
        checkFieldState(field) {
            return field.$dirty ? !field.$invalid : null
        },
        parseFormToApi() {
            return {
                title: this.form.title,
                user_id: this.form.responsible.value,
                key_result_id: this.form.key_result_id,
                due_date: this.form.due_date,
                status: this.form.status,
            }
        },
        resetFormData() {
            this.setFormDefaultData()
            this.$nextTick(() => this.resetFormState())
            if (this.$refs.selectKeyResult) {
                this.$refs.selectKeyResult.reset()
            }
        },
        setFormDefaultData() {
            this.form = { ...DEFAULT_FORM_DATA }
        },
        resetFormState() {
            this.$v.$reset()
        },
    },
}
</script>
<style lang="scss" scoped>
.label-style {
    color: #022b4f;
    font-size: 16px;
    font-weight: 700;
}

::v-deep legend {
    @extend .label-style;
}

::v-deep label {
    @extend .label-style;
}
</style>
